<div class="sticker-placeholder"
     [style.width.mm]="control().stickerWidth || 100"
     [style.height.mm]="control().stickerHeight || 60">
  <span class="sticker-dims">{{ control().stickerWidth || 100 }} × {{ control().stickerHeight || 60 }} mm</span>
</div>
